import React, { useCallback, useEffect, useState } from "react";
import { apiUrl } from "../taskpane";
import { approveSnapshot, createShare, fetchShares, revokeShare } from "../api/productTablesApi";
import { confirmDialog } from "../utils/confirmDialog";

const btn = {
  padding: "4px 10px", fontSize: 11, borderRadius: 6, cursor: "pointer",
  background: "transparent", border: "1px solid #3a5a7a", color: "#7bc8ff",
};

// Approve + client-link controls for the save selected in the history timeline.
export default function BoqShareSection({ token, projectId, snap, onApproved }) {
  const [shares, setShares] = useState([]);
  const [details, setDetails] = useState(false);
  const [days, setDays] = useState(30);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const load = useCallback(async () => {
    try { setShares((await fetchShares(token, projectId)) || []); } catch { setShares([]); }
  }, [token, projectId]);
  useEffect(() => { load(); }, [load]);

  const approve = async () => {
    setErr(""); setMsg("");
    const ok = await confirmDialog(
      "ვერსია დამტკიცდება და ჩაიკეტება: შენახვა, აღდგენა და ფასების განახლება გაითიშება, სანამ დამტკიცებას არ გააუქმებ. ახალი სცენარისთვის შეგიძლია გამოიყენო „ახალი ვერსია“. გაგრძელება?"
    );
    if (!ok) return;
    setBusy(true);
    try {
      await approveSnapshot(token, projectId, snap.id, "");
      setMsg("✓ ვერსია დამტკიცდა და ჩაკეტილია.");
      if (onApproved) await onApproved();
    } catch (e) {
      setErr(e.message || "Approve failed");
    } finally { setBusy(false); }
  };

  const share = async () => {
    setErr(""); setMsg("");
    setBusy(true);
    try {
      await createShare(token, projectId, snap.id, { include_details: details, days: Number(days) || 30 });
      await load();
    } catch (e) {
      setErr(e.message || "Share failed");
    } finally { setBusy(false); }
  };

  const copy = async (url) => {
    try { await navigator.clipboard.writeText(url); setMsg("✓ ბმული დაკოპირდა"); }
    catch { setMsg("დააკოპირე ბმული ხელით (მონიშნე და Ctrl+C)"); }
  };

  const revoke = async (s) => {
    try { await revokeShare(token, projectId, s.id); await load(); } catch (e) { setErr(e.message); }
  };

  return (
    <div style={{ padding: "8px 10px", borderBottom: "1px solid #2a3a4a" }}>
      <div style={{ fontSize: 11, color: "#aaa", marginBottom: 6 }}>
        არჩეული შენახვა: {snap ? new Date(snap.created_at).toLocaleString("ka-GE") : "— აირჩიე ჩამონათვალიდან"}
      </div>
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center" }}>
        <button style={{ ...btn, borderColor: "#34d399", color: "#34d399" }} disabled={!snap || busy} onClick={approve}>
          ✔ დამტკიცება და ჩაკეტვა
        </button>
        <span style={{ color: "#555" }}>|</span>
        <label style={{ fontSize: 11, color: "#aaa", cursor: "pointer" }}>
          <input type="checkbox" checked={details} onChange={(e) => setDetails(e.target.checked)} /> დეტალებით
        </label>
        <input
          type="number" min={1} max={365} value={days} onChange={(e) => setDays(e.target.value)}
          title="ვადა დღეებში" style={{ width: 52, padding: "3px 6px", borderRadius: 6, fontSize: 11 }}
        />
        <span style={{ fontSize: 11, color: "#aaa" }}>დღე</span>
        <button style={btn} disabled={!snap || busy} onClick={share}>🔗 ბმული დამკვეთისთვის</button>
      </div>

      {msg && <div style={{ marginTop: 6, fontSize: 11, color: "#34d399" }}>{msg}</div>}
      {err && <div style={{ marginTop: 6, fontSize: 11, color: "#fb7185" }}>{err}</div>}

      {shares.length > 0 && (
        <div style={{ marginTop: 8, display: "flex", flexDirection: "column", gap: 6 }}>
          {shares.map((s) => {
            const url = apiUrl(s.path);
            return (
              <div key={s.id} style={{ background: "#1e2a38", borderRadius: 6, padding: "6px 8px" }}>
                <div style={{ fontSize: 10, color: "#888", marginBottom: 3 }}>
                  შენახვა #{s.snapshot_id} · {s.include_details ? "დეტალებით" : "მხოლოდ თავები"} · მოქმედებს {new Date(s.expires_at).toLocaleDateString("ka-GE")}-მდე
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                  <input readOnly value={url} onFocus={(e) => e.target.select()} style={{ flex: 1, minWidth: 0, fontSize: 11, padding: "3px 6px", borderRadius: 6 }} />
                  <button style={btn} onClick={() => copy(url)}>კოპირება</button>
                  <button style={{ ...btn, borderColor: "#fb7185", color: "#fb7185" }} onClick={() => revoke(s)}>გაუქმება</button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
